import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Card} from 'antd';
import {Link} from 'react-router-dom';
import {ColumnProps} from 'antd/lib/table';

import {GET_MEMBERSHIPS} from '../../graphql';
import {ListMembership, ParsedListMembership} from '../../interfaces';

import MembershipList from './components/MembershipList';

import './styles.css';

interface Properties {
  regionId: string;
  clubId: string;
}

class MembershipListWrap extends Component<Properties> {
  render() {
    const {clubId, regionId} = this.props;
    return (
      <Query query={GET_MEMBERSHIPS} variables={{clubId}}>
        {({loading, error, data: {memberships}}: any) => {
          if (loading) {
            return <Card loading={loading} />;
          }

          if (error) {
            return `Error! ${error.message}`;
          }

          const dataSource: Array<ParsedListMembership> = memberships.map((membership: ListMembership, key: number) => ({
            key,
            id: membership.id,
            code: membership.membershipExternalId,
            active: membership.active,
            ospAvailable: membership.ospAvailable,
            dspAvailable: membership.dspAvailable,
            isDefault: membership.isDefault,
            priority: membership.priority,
            price: membership.price,
            title: membership.title,
          }));

          const columns: Array<ColumnProps<ParsedListMembership>> = [
            {
              title: '#',
              dataIndex: 'id',
              key: 'id',
              render: (id: String, record: ParsedListMembership) => <Link to={`/memberships/${regionId}/${clubId}/${record.code}`}>{Number(id) || ''}</Link>,
            },
            {
              title: 'code',
              dataIndex: 'code',
              key: 'code',
              render: (code: String) => <Link to={`/memberships/${regionId}/${clubId}/${code}`}>{code}</Link>,
            },
            {
              title: 'title',
              dataIndex: 'title',
              key: 'title',
            },
            {
              title: 'price',
              dataIndex: 'price',
              key: 'price',
              render: (price: string) => price || '-',
            },
            {
              title: 'active',
              dataIndex: 'active',
              key: 'active',
              render: (active: boolean) => (active ? 'yes' : 'no'),
            },
            {
              title: 'OSP / DSP',
              dataIndex: 'ospAvailable',
              key: 'ospAvailable',
              render: (ospAvailable: boolean, record: any) => {
                return `${ospAvailable ? 'yes' : 'no'} / ${record.dspAvailable ? 'yes' : 'no'}`;
              },
            },
            {
              title: 'priority',
              dataIndex: 'priority',
              key: 'priority',
            },
            {
              title: 'Set to Default',
              dataIndex: 'isDefault',
              key: 'isDefault',
              render: (isDefault: boolean) => (isDefault ? 'yes' : 'no'),
            },
          ];

          return <MembershipList dataSource={dataSource} columns={columns} />;
        }}
      </Query>
    );
  }
}

export default MembershipListWrap;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipList/MembershipListWrap.tsx